module.exports = __webpack_public_path__ + "static/img/micro-phone.169a936a.svg";